Vue.component('ack-klaviyo-embed', {
	delimiters: ['${', '}$'],
	template: '#ack-klaviyo-embed',
	mounted() {
		this.setKlaviyoWidget();
	},
	props: {
		pageId: 'klaviyo-embed',
		widgetType: {
			type: String,
			required: true,
		},
	},
	computed: {
		isScriptExist() {
			return Array.from(document.getElementsByTagName('script')).some(
				(script) => script.src === this.klaviyoScriptSrc,
			);
		},
	},

	data() {
		return {
			currentClass: '',
			klaviyoWidgetClasses: {
				signUpNewsLetter: 'klaviyo-form-RhSUM9',
				installationPortalNewsletter: 'klaviyo-form-TTyS2H',
				newsletter: 'klaviyo-form-TZRNZP',
			},

			klaviyoScriptSrc: 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=YwZMB4',
		};
	},

	methods: {
		setKlaviyoWidget() {
			if (!this.widgetType) return;
			this.currentClass = this.klaviyoWidgetClasses[this.widgetType];
			if (!this.isScriptExist) {
				const script = document.createElement('script');
				script.src = this.klaviyoScriptSrc;
				script.async = true;
				script.type = 'text/javascript';
				document.body.appendChild(script);
			}
		},
	},
});
